import {Multimedia} from '@/types/matrix';
import {Box, Card, CardMedia} from '@mui/material';

import VideoPreviewWithPlayIcon from '@/components/matrix-chat/ui/video-preview-with-play-icon';
interface BoxWithFourElementsProps {
  urls: string[];
  multimediaType: Multimedia;
  handleOpenFullScreen: (url: string) => void;
}
const BoxWithFourElements: React.FC<BoxWithFourElementsProps> = ({
  urls,
  multimediaType,
  handleOpenFullScreen
}) => {
  const cardProps = {
    height: {xs: '75px', md: '150px'},
    width: {xs: '75px', md: '150px'}
  };

  const cardMediaProps = {
    cursor: 'pointer',
    objectFit: 'cover',
    height: {xs: '75px', md: '150px'},
    width: {xs: '75px', md: '150px'}
  };

  const isVideo = multimediaType === 'video';

  const columns = urls.map((url, index) => (
    <Box key={url} sx={{...cardProps}}>
      <Card sx={cardProps}>
        {isVideo ? (
          <VideoPreviewWithPlayIcon
            url={urls[index]}
            handleOpenFullScreen={handleOpenFullScreen}
          />
        ) : (
          <CardMedia
            component="img"
            image={urls[index]}
            alt={`${multimediaType} ${index + 1}`}
            onClick={() => handleOpenFullScreen(urls[index])}
            sx={cardMediaProps}
          />
        )}
      </Card>
    </Box>
  ));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        //gap: '5px',
        maxWidth: {xs: '150px', md: '300px'},
        maxHeight: {xs: '150px', md: '300px'}
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column'
          //gap: '5px'
        }}
      >
        {columns.slice(0, 2)}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column'
          //gap: '5px'
        }}
      >
        {columns.slice(2, 4)}
      </Box>
    </Box>
  );
};

export default BoxWithFourElements;
